var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-body"},[_c('h2',[_vm._v("Beliebte Produktkategorien")]),_vm._v(" "),_c('apexchart',{attrs:{"width":"420","type":"donut","options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }